@if (events() && events().length > 0) {
	<div class="p-2 mb-6 rounded-lg bg-uc-blue-900">
		<span class="inline-block pt-1 pb-3 pl-2 text-sm text-white"
			>Recommended Events</span
		>
		<div class="flex flex-col gap-4 rounded-lg">
			@for (event of events(); track $index) {
				<div
					class="flex flex-col justify-between bg-white rounded-lg sm:flex-row"
				>
					<div
						class="flex flex-col items-center w-full px-6 py-6 rounded-t-lg sm:rounded-tr-none sm:rounded-l-lg sm:flex-row sm:pr-0"
					>
						<div
							class="w-full p-6 border border-gray-200 rounded-md sm:max-w-max"
						>
							<p class="text-5xl font-bold text-center">
								{{ event.date | date: 'd' }}
							</p>
							<p class="text-base text-center whitespace-nowrap">
								{{ event.date | date: 'MMM, YYY' }}
							</p>
						</div>
						<div
							class="flex flex-col items-center mt-4 sm:ml-4 sm:mt-0 sm:self-center sm:block"
						>
							<h3 class="-mb-1 text-lg font-medium">
								<a [routerLink]="['/universities', uniSlug()]">
									{{ uniName() | ucEntities }}
								</a>
							</h3>

							<div class="text-base text-center text-gray-500 sm:text-left">
								@if (event.description) {
									<p>{{ event.description | ucEntities }}</p>
								}
								@if (event.subtitle) {
									<p>{{ event.subtitle | ucEntities }}</p>
								}
							</div>
						</div>
					</div>
					<div
						class="relative flex items-center justify-center pt-0 pb-6 bg-white rounded-b-lg sm:rounded-bl-none sm:rounded-r-lg sm:pl-4 sm:py-6 sm:w-56 sm:border-l-2 sm:border-gray-200 sm:border-dashed"
					>
						<uc-book-event-btn
							class="w-full mx-3 sm:w-auto sm:mx-0"
							[externalUrl]="event.external_url"
							[eventType]="event.type"
							[date]="event.date"
							[uniId]="uniId()"
							customStyles="w-full sm:w-auto book-event-btn mx-auto"
							[componentName]="componentName()"
							[product]="event.product | productToLowercase"
							[eventId]="event.id"
							[ugSearchOrderPosition]="ugSearchOrderPosition()"
							[privacyPolicyUrl]="privacyPolicyUrl()"
							[uniName]="uniName()"
						/>
					</div>
				</div>
			}
		</div>
	</div>
}
